import { render, staticRenderFns } from "./AppFooterLower.vue?vue&type=template&id=100522cf&scoped=true"
import script from "./AppFooterLower.vue?vue&type=script&lang=js"
export * from "./AppFooterLower.vue?vue&type=script&lang=js"
import style0 from "./AppFooterLower.vue?vue&type=style&index=0&id=100522cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100522cf",
  null
  
)

export default component.exports